import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformfeature() {
  return (
    <section className="platform_feature p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/features.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={684}
                height={750}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Platform <span>Features</span>
            </h2>
            <p>
              Enjoy the perfect mix of Spanish and Indian board games with more
              competitive rules, stronger AI, better matching, and enhanced user
              experience with Parcheesi Cash.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
